import { create } from 'zustand'
import { CreateExampleStore, ExampleAction, ExampleState } from './_types'

const exampleReducer = (state: ExampleState, action: ExampleAction) => {
    switch (action.type) {
        case 'increment':
            return { count: state.count + action.amount }
        case 'decrement':
            return { count: state.count - action.amount }
        default:
            return state
    }
}

export const useExampleStore = create<CreateExampleStore<ExampleState, ExampleAction>>((set) => ({
    count: 0,
    dispatch: (action) => set((state) => exampleReducer(state, action)),
}))
